/**
 * Shared appointment filter utilities.
 * Used by appointments-calendar and appointments-table.
 */
import { firstValueFrom, forkJoin } from 'rxjs';

/**
 * Resolve a list of employee IDs to their full names, by fetching employees
 * from every location available in the ProfileService.
 *
 * @param employeeIds - IDs to resolve
 * @param profileService - Must expose a BehaviorSubject-backed `locations$`
 * @param apiService - Must expose `getEmployeesByLocation(locationId)`
 */
export async function mapEmployeeIdsToNames(
  employeeIds: string[],
  profileService: { locations$: any },
  apiService: { getEmployeesByLocation(id: string): any }
): Promise<string[]> {
  try {
    const locations: any[] = (profileService.locations$ as any).source?.value || [];
    if (locations.length === 0) return [];

    const responses: any = await firstValueFrom(
      forkJoin(locations.map((loc: any) => apiService.getEmployeesByLocation(loc.id)))
    );

    const allEmployees: any[] = [];
    if (Array.isArray(responses)) {
      responses.forEach((r: any) => {
        if (r?.status && Array.isArray(r.data)) allEmployees.push(...r.data);
      });
    }

    return allEmployees
      .filter(e => employeeIds.includes(e.id))
      .map(e => `${e.first_name} ${e.last_name}`);
  } catch {
    return [];
  }
}
